import {
  NotificationsProvider,
  RouterEffectsProvider,
} from '@/shared/lib/providers'
import { type Scope } from 'effector'
import { Provider } from 'effector-react'
import { BrowserRouter } from 'react-router-dom'

import './init'
import { ErrorBoundaryRedirect } from './providers/error-boundary'
import { ThemeProvider } from './providers/theme'
import { Router } from './router'
import './styles'

export { appStarted } from './init/init.model'
type AppProps = {
  scope: Scope
}
export const App = ({ scope }: AppProps) => {
  return (
    <Provider value={scope}>
      <ThemeProvider>
        <NotificationsProvider>
          <BrowserRouter>
            <RouterEffectsProvider>
              <ErrorBoundaryRedirect>
                <Router />
              </ErrorBoundaryRedirect>
            </RouterEffectsProvider>
          </BrowserRouter>
        </NotificationsProvider>
      </ThemeProvider>
    </Provider>
  )
}
